export default __webpack_public_path__ + "static/media/roulette-selector.d7830f16.svg";